<template>
    <div class="sub-nav">
        <div class="header">
            <div v-html="nav.title"></div>
            <div v-if="nav.subtitle" class="sub-header">
                {{ nav.subtitle }} plan
            </div>
        </div>

        <div v-for="(item, idx) in items" :key="item.title">
            <div
                v-if="item.type === 'link'"
                :class="['link link-inner', { selected: item.selected }]"
                @click="toggleClose(item, idx)"
            >
                <span v-html="item.title"></span>
                <span v-if="item.hasSubLinks">
                    <i
                        v-if="!item.closed"
                        class="uk-icon-angle-up uk-margin-small-left uk-text-bold"
                    ></i>
                    <i
                        v-else
                        class="uk-icon-angle-down uk-margin-small-left uk-text-bold"
                    ></i>
                </span>
            </div>

            <SlideUpDown
                v-else-if="item.type === 'sublinks'"
                :active="!item.closed"
                :duration="500"
                class="sublinks"
            >
                <div class="sublinks-inner">
                    <div
                        v-for="sublink in item.links"
                        :key="sublink.id"
                        :class="[
                            'link sublinks-link',
                            { selected: sublink.selected },
                        ]"
                        @click="toggleClose(sublink, idx)"
                    >
                        <span class="sub-link-text">{{ sublink.title }}</span>
                    </div>
                </div>
            </SlideUpDown>
        </div>

        <div class="logo">
            <div class="logo-pad"></div>
            <div class="logo-img">
                <CompanyLogo :url="logoImg" />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-facing-decorator'
import SlideUpDown from 'vue-slide-up-down'
import { Nav, NavItem } from '@/pages/dashboard/entities/nav'
import CompanyLogo from '@/components/CompanyLogo.vue'
import { getCDNUrl } from '@/utils/cdn'

interface Selectable {
    selected?: boolean
}

type MenuBlock =
    | ({
          type: 'link'
          to?: string
          title: string
          selected?: boolean
          closed?: boolean
          hasSubLinks: boolean
      } & NavItem &
          Selectable)
    | {
          type: 'sublinks'
          id: string
          closed?: boolean
          href?: string
          target?: string
          links: Array<NavItem & Selectable>
      }

@Component({
    components: { CompanyLogo, SlideUpDown },
})
export default class SubNavApp extends Vue {
    @Prop({ type: Object, required: true }) public nav!: Nav
    public items = this.getItems()

    public get logoImg() {
        return getCDNUrl(this.nav.logo)
    }

    public getItems() {
        const { nav } = this
        const navItems = (nav && nav.items) || []

        const links: MenuBlock[] = []

        navItems.forEach((item) => {
            const hasSubLinks = !!(
                item.items &&
                item.items[0] &&
                item.items[0].title
            )

            const closed =
                (item.items || []).filter((a) => a.selected).length === 0
            if (item.title) {
                links.push({
                    id: item.title,
                    type: 'link',
                    title: item.title,
                    selected: !closed || item.selected,
                    closed,
                    href: item.href || '#',
                    target: item.target || '',
                    hasSubLinks,
                })
            }

            if (hasSubLinks) {
                links.push({
                    type: 'sublinks',
                    id: item.title as string,
                    closed,
                    links: item.items || [],
                    href: item.href || '#',
                    target: item.target || '',
                })
            }
        })

        return links
    }

    public shouldMaskPrevious(idx: number): boolean {
        const prev = this.items[idx - 1]
        return (
            prev &&
            prev.type === 'sublinks' &&
            prev.links &&
            prev.links.length > 5
        )
    }

    public toggleClose(item, idx) {
        if (item.hasSubLinks) {
            if (!item.closed) {
                // close current
                item.closed = !item.closed
                this.items[idx + 1].closed = item.closed
            } else {
                this.items.map((a, i) => {
                    if ((a as any).hasSubLinks) {
                        this.items[i + 1].closed = a.closed = a !== item
                    }
                })
            }
        } else {
            if (item.target === '_blank') {
                window.open(item.href, '_blank')
            } else {
                window.location.href = item.href
            }
        }
    }
}
</script>

<style lang="less">
@import '../../../pages/dashboard/components/DashboardSubNav';
/* share same style with dashboard subnav */
.sub-nav {
    /* html content populated by PHP */

    .switch-user {
        font-size: 11px;
        display: block;
        color: inherit;
        text-decoration: none;
        font-weight: 200;
        word-break: break-word;
    }

    .sub-header {
        color: #96a0aa;
        font-size: 11px;
        letter-spacing: 1px;
        line-height: 13px;
        text-transform: uppercase;
        font-weight: 200;
        margin-top: 5px;
        opacity: 0.8;
        word-break: break-word;
    }
}
</style>
